import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לשים לב לחוסר ההגנה",
    opening: localizedGenderNode(
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לחוסר ההגנה.",
      "זה מספיק לרגע."
    ],
      [
      "היום אני לא מנסה לתקן.",
      "אני רק שם/ה לב לחוסר ההגנה.",
      "זה מספיק לרגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי חוסר ההגנה הכי מורגש לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ],
      [
      "מתי חוסר ההגנה הכי מורגש לי?",
      "מה קורה סביבי אז?",
      "איך זה מרגיש בגוף שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב זה כבר התחלה של הגנה פנימית."
    ],
      [
      "לשים לב זה כבר התחלה של הגנה פנימית."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת עם המילים \"אני כאן\".",
      "נשימה אחת עם המילים \"אני כאן\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "מה הייתי בוחר/ה",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שהייתי בוחר/ת/ה אז.",
      "בלי האשמה.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב למה שהייתי בוחר/ת/ה אז.",
      "בלי האשמה.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את החזה."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הייתי בוחר/ת/ה לשמוע אז?",
      "מה הייתי בוחר/ת/ה שיקרה?",
      "מה עדיין חסר לי היום?"
    ],
      [
      "מה הייתי בוחר/ת/ה לשמוע אז?",
      "מה הייתי בוחר/ת/ה שיקרה?",
      "מה עדיין חסר לי היום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשים לב לצורך הוא כבר רוך."
    ],
      [
      "לשים לב לצורך הוא כבר רוך."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת על הצורך.",
      "לכתוב מילה אחת על הצורך."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "איך זה נשאר בי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב למה שנשאר בי מאז.",
      "בלי שיפוט.",
      "רק אמת."
    ],
      [
      "היום אני שם/ה לב למה שנשאר בי מאז.",
      "בלי שיפוט.",
      "רק אמת."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה זה פוגש אותי היום?",
      "מה אני מנסה למנוע מעצמי להרגיש?",
      "איך זה משפיע על קשרים?"
    ],
      [
      "איפה זה פוגש אותי היום?",
      "מה אני מנסה למנוע מעצמי להרגיש?",
      "איך זה משפיע על קשרים?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "מה שנשאר בי מבקש עדינות."
    ],
      [
      "מה שנשאר בי מבקש עדינות."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "החלק שמרגיש לא מוגן",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לחלק בי שמרגיש לא מוגן.",
      "לא לתקן.",
      "רק להיות איתו."
    ],
      [
      "היום אני שם/ה לב לחלק בי שמרגיש לא מוגן.",
      "לא לתקן.",
      "רק להיות איתו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הלב."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ],
      [
      "איפה הוא יושב בי?",
      "מה הוא בוחר/ת ממני עכשיו?",
      "איך זה מרגיש להיות איתו רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ],
      [
      "להיות איתו לרגע הוא כבר שינוי קטן."
    ]
    ),
    action: localizedGenderNode(
      "לשים יד על הלב ולנשום.",
      "לשים יד על הלב ולנשום."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שלא יהיה מי",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לפחד שלא יהיה מי.",
      "לא להילחם.",
      "רק לראות."
    ],
      [
      "היום אני שם/ה לב לפחד שלא יהיה מי.",
      "לא להילחם.",
      "רק לראות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת כאן?",
      "מה אני חושב/ת שיקרה אם אבקש?",
      "איך הפחד הזה שומר עליי?"
    ],
      [
      "ממה אני מפחד/ת כאן?",
      "מה אני חושב/ת שיקרה אם אבקש?",
      "איך הפחד הזה שומר עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הפחד מבקש שמירה."
    ],
      [
      "הפחד מבקש שמירה."
    ]
    ),
    action: localizedGenderNode(
      "לומר לעצמי \"אני רואה אותך\".",
      "לומר לעצמי \"אני רואה אותך\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "בקשה קטנה להגנה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה קטנה להגנה.",
      "לא גדולה.",
      "קטנה."
    ],
      [
      "היום אני מנסח/ת בקשה קטנה להגנה.",
      "לא גדולה.",
      "קטנה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה נותן לי תחושת הגנה קטנה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה נותן לי תחושת הגנה קטנה?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת יכולה להרגיע."
    ],
      [
      "בקשה אחת יכולה להרגיע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "רגע קטן של ביטחון",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת רגע קטן של ביטחון.",
      "לא הרבה.",
      "רק מעט."
    ],
      [
      "היום אני מחפש/ת רגע קטן של ביטחון.",
      "לא הרבה.",
      "רק מעט."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מתי הרגשתי ביטחון קטן לאחרונה?",
      "מה אפשר לו לקרות?",
      "מה יכול להזמין עוד רגע כזה?"
    ],
      [
      "מתי הרגשתי ביטחון קטן לאחרונה?",
      "מה אפשר לו לקרות?",
      "מה יכול להזמין עוד רגע כזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "לזכור רגע כזה.",
      "לזכור רגע כזה."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "גבול שמגן עליי",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ],
      [
      "היום אני בודק/ת גבול קטן שמגן עליי.",
      "לא כדי להתרחק.",
      "רק לשמור."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הכתפיים."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ],
      [
      "איפה אני נותן/ת יותר מדי?",
      "איזה גבול קטן יקל עליי?",
      "איך אני יכול/ה לומר אותו לעצמי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "גבול קטן שומר על הלב."
    ],
      [
      "גבול קטן שומר על הלב."
    ]
    ),
    action: localizedGenderNode(
      "משפט גבול אחד לעצמי.",
      "משפט גבול אחד לעצמי."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "להישאר עם עצמי",
    opening: localizedGenderNode(
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה חוסר ההגנה.",
      "לא לברוח.",
      "רק להיות."
    ],
      [
      "היום אני מתרגל/ת להישאר עם עצמי כשעולה חוסר ההגנה.",
      "לא לברוח.",
      "רק להיות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ],
      [
      "מה עוזר לי להישאר איתי?",
      "מה מוציא אותי מעצמי?",
      "מה יכול לעזור לי לחזור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להישאר איתי הוא עוגן קטן."
    ],
      [
      "להישאר איתי הוא עוגן קטן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת בכל פעם שעולה התחושה.",
      "נשימה אחת בכל פעם שעולה התחושה."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "בקשה אחת ברורה",
    opening: localizedGenderNode(
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ],
      [
      "היום אני מנסח/ת בקשה אחת ברורה לעצמי.",
      "לא גדולה.",
      "ברורה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש מוגן/ת?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ],
      [
      "מה אני בוחר/ת/ה עכשיו כדי להרגיש מוגן/ת?",
      "איך אפשר לבקש זאת בעדינות?",
      "מה צעד קטן בכיוון?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ],
      [
      "בקשה אחת ברורה יכולה להרגיע."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הבקשה במשפט אחד.",
      "לכתוב את הבקשה במשפט אחד."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "ערך אחד שמחזיק אותי",
    opening: localizedGenderNode(
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ],
      [
      "היום אני מחפש/ת ערך אחד שמחזיק אותי.",
      "קטן.",
      "אבל אמיתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה ערך חשוב לי בתוך קשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ],
      [
      "איזה ערך חשוב לי בתוך קשר?",
      "איך הערך הזה נראה ביום רגיל?",
      "מה צעד קטן שיכבד אותו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ערך אחד הוא חוט של יציבות."
    ],
      [
      "ערך אחד הוא חוט של יציבות."
    ]
    ),
    action: localizedGenderNode(
      "מילה אחת שמבטאת את הערך.",
      "מילה אחת שמבטאת את הערך."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "להקשיב לצורך שלי",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לצורך שלי.",
      "לא לדחות.",
      "רק לשמוע."
    ],
      [
      "היום אני מקשיב/ה לצורך שלי.",
      "לא לדחות.",
      "רק לשמוע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ],
      [
      "אני נושם/ת לאט.",
      "אני מרגיש/ה את הבטן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה הצורך הכי חי בי עכשיו?",
      "איך הוא נשמע במילים פשוטות?",
      "מה יכול לתת לו טיפת מקום?"
    ],
      [
      "מה הצורך הכי חי בי עכשיו?",
      "איך הוא נשמע במילים פשוטות?",
      "מה יכול לתת לו טיפת מקום?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "לשמוע את הצורך הוא כבר שינוי."
    ],
      [
      "לשמוע את הצורך הוא כבר שינוי."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב את הצורך במילה אחת.",
      "לכתוב את הצורך במילה אחת."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן של ביטחון",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן של ביטחון.",
      "בלי דרמה.",
      "צעד קטן."
    ],
      [
      "היום אני בוחר/ת צעד קטן של ביטחון.",
      "בלי דרמה.",
      "צעד קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ],
      [
      "מה צעד קטן שאני מוכן/ה לנסות?",
      "מה ירגיש לי בטוח מספיק?",
      "איך זה ישמור עליי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "צעד קטן מספיק כדי להתקרב."
    ],
      [
      "צעד קטן מספיק כדי להתקרב."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד אחד קטן ולזכור אותו.",
      "לבחור צעד אחד קטן ולזכור אותו."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להגנה פנימית.",
      "כשאני נבהל/ת.",
      "משפט קטן."
    ],
      [
      "היום אני בוחר/ת משפט שמחזיר אותי להגנה פנימית.",
      "כשאני נבהל/ת.",
      "משפט קטן."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת.",
      "אני כאן."
    ],
      [
      "אני נושם/ת.",
      "אני כאן."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על חוסר ההגנה הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ],
      [
      "מה למדתי על חוסר ההגנה הזה?",
      "מה הסימן הראשון שהוא חוזר?",
      "איזה משפט מחזיר אותי רגע לפני?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני יכול/ה להרגיש לא מוגן/ת ולהישאר עם עצמי."
    ],
      [
      "אני יכול/ה להרגיש לא מוגן/ת ולהישאר עם עצמי."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט החדש פעם אחת.",
      "לומר את המשפט החדש פעם אחת."
    ),
  },
].map(buildNormalizedDay);

export const lackOfProtectionChildhoodWereNotThereForMeBlueprintHe = buildNormalizedPilotBlueprint({
  id: "lack_of_protection_childhood_were_not_there_for_me_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "lack_of_protection_childhood_were_not_there_for_me",
  category: "childhood_parents_past_wounds",
  journeyName: {
    he: "חוסר הגנה בילדות (לא היו שם בשבילי)",
    en: "Lack of protection in childhood (they were not there for me)",
    es: "Falta de protección en la infancia (no estuvieron para mí)",
  },
  days,
});

export default lackOfProtectionChildhoodWereNotThereForMeBlueprintHe;
